import React from 'react';
import styled from 'styled-components';
import Reels from './Reels';

const ShopContainer = styled.div`
  width: 100%;
  background: url('./img/bg.jpg');
  height: 650px;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;

  @media (max-width: 768px) {
    height: 560px;
  }
`;

const ShopContent = styled.div`
  text-align: center;
`;

const Heading2 = () => {
  return (
    <ShopContainer>
      <ShopContent className="container">
        <Reels />
      </ShopContent>
    </ShopContainer>
  );
};

export default Heading2;
